module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('nav', {
    attrs: {
      "epub:type": "toc",
      "id": "toc",
      "role": "doc-toc"
    }
  }, [_c('h1', {
    attrs: {
      "id": "toc-title"
    }
  }, [_vm._v("Beautiful Star & Other Stories")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', [_c('span', {
    attrs: {
      "href": "#/text/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "title_page"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/title_page"
    }
  }, [_vm._v("Title Page")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch001#dedication"
    }
  }, [_vm._v("Dedication")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-2"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch002#preface"
    }
  }, [_vm._v("Preface")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-3"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#beautiful-star"
    }
  }, [_vm._v("Beautiful Star")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-4"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/text/ch003#section"
    }
  }, [_vm._v("1875")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-5"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#authors-note",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Author’s Note")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-6"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#the-st-monans-families-were",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The St Monans families were:")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-7"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch004#the-lost-boats-and-their-crews-were",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The lost boats and their crews were:")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-8"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#the-flying-monk",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Flying Monk")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-9"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#ad",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1002 AD")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-10"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch005#ad-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1066 AD")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-11"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#hms-association",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("HMS "), _c('em', [_vm._v("Association")])]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-12"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#section-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1708")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-13"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch006#a-true-account-of-the-final-voyage-of-hms-association-by-daniel-jones-pressed-man.",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A true account of the final voyage of HMS "), _c('em', [_vm._v("Association")]), _vm._v(" by Daniel Jones, pressed man.")])])])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-14"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#the-tree",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Tree")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-15"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch007#section-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1651")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-16"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#the-castle",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Castle")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-17"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch008#june-1645",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("June 1645")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-18"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#a-witch-and-a-bitch",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Witch and a Bitch")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-19"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch009#section-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1730")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-20"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-button-seller-and-the-drummer-boy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Button Seller and the Drummer Boy")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-21"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#section-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1815")]), _vm._v(" "), _c('ol', {
    staticClass: "toc"
  }, [_c('li', {
    attrs: {
      "id": "toc-li-22"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-button-seller",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Button Seller")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-23"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#the-drummer-boy",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Drummer Boy")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-24"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch010#section-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1820")])])])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-25"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch011#acknowledgements",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('li', {
    attrs: {
      "id": "toc-li-26"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/text/ch012#copyright",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Copyright")])])])]), _vm._v(" "), _c('nav', {
    attrs: {
      "epub:type": "landmarks",
      "hidden": "hidden",
      "id": "landmarks"
    }
  }, [_c('ol', [_c('li', [_c('span', {
    attrs: {
      "epub:type": "cover",
      "href": "#/text/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Cover")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "toc",
      "href": "#/nav#toc"
    }
  }, [_vm._v("Table of Contents")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "epub:type": "bodymatter",
      "href": "#/text/title_page"
    }
  }, [_vm._v("Start of Content")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41e49fa1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav.vue
// module id = 57
// module chunks = 0